import { HidingContentSwitcher, Collection, Ref } from "@tblabs/truffle";
import { Field } from "../../../Models/Description/Field";
import { Tab } from "../../../Models/Product/Tab";
import { DescriptionPrinter } from "./DescriptionPrinter";


export class TabsSwitcher extends HidingContentSwitcher
{
    constructor(tabs: Collection<Tab>, description: Collection<Field>, selectedTab: Ref<string>)
    {
        super(selectedTab);

        this.Class("tabs__content product-info__tab-content");

        tabs.Items.map(tab =>
        {
            const tabFields = description.Filter(x => x.Tab.value === tab.Id.value);
            this.AddContent(tab.Label.value, () => new DescriptionPrinter(tabFields));
        });

        this.Refresh();
    }
}
